// Polyfills
// import 'whatwg-fetch' // fetch API: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
// import 'intersection-observer' // Intersection Observer API: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
import 'classlist-polyfill'
import smoothscroll from 'smoothscroll-polyfill'

// Global tooling
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit.js' // Parent-fit-plugin for lazysizes, make data-sizes="auto" work well with object-fit
import 'lazysizes/plugins/object-fit/ls.object-fit'
// import 'simplebar' // or "import SimpleBar from 'simplebar';" if you want to use it manually.

import initMobileMenuController from './init-mobile-menu-controller'
import initHeroSlideshows from './init-hero-slideshows'
import PhotoGallery from './init-photo-gallery'
import initGetScouted from './init-get-scouted'
import initSmoothAnchorScroll from './init-smooth-anchor-scroll'
import initVhCssVariable from './init-vh-css-variable'
import initVimeoVideos from './init-vimeo-videos'
import initVideoCovers from './init-video-covers'

// Bootstrap polyfills
smoothscroll.polyfill()

const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 2000
}

initMobileMenuController()
initHeroSlideshows()
PhotoGallery(breakpoints)
initGetScouted()
initVimeoVideos()
initSmoothAnchorScroll()
initVhCssVariable()
initVideoCovers()
